import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const DarkMode = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,

      primary: {
        main: '#f56a00',
      },
      secondary: {
        main: '#8E9BFF',
      },

      error: {
        main: '#ff0000',
      },
      warning: {
        main: '#ff2500',
      },
      info: {
        main: '#ffad08',
      },
      success: {
        main: '#00cd00',
      },

      background: {
        default: '#1F2326',
        paper: '#2C2F33',
      },

      text: {
        primary: '#FFFFFF',
        secondary: '#B3B3B3',
      },

      divider: '#333333',

      banner: {
        info: '#64B5F6',
        error: '#E57373',
        warning: '#FFB74D',
        text: '#FFFFFF',
        link: '#8E9BFF',
      },
      errorBackground: '#f44336',
      warningBackground: '#4E342E',
      infoBackground: '#283593',

      navigation: {
        background: '#1E1E1E',
        indicator: '#8E9BFF',
        color: '#FFFFFF',
        selectedColor: '#f56a00',
        hoverBackground: 'rgba(142, 155, 255, 0.1)',
        hoverColor: '#FFFFFF',
        activeBackground: 'rgba(142, 155, 255, 0.2)',
        activeColor: '#FFFFFF',
        subtitleColor: '#B3B3B3',
        buttonPosition: 'below',
      },
    },
  }),

  defaultPageTheme: 'home',

  fontFamily: 'Arial, sans-serif',

  pageTheme: {
    home: genPageTheme({
      colors: ['#121212', '#1E1E1E'],
      shape: shapes.wave,
    }),
    documentation: genPageTheme({
      colors: ['#121212', '#1E1E1E'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: ['#121212', '#1E1E1E'],
      shape: shapes.round,
    }),
    service: genPageTheme({
      colors: ['#121212', '#1E1E1E'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#121212', '#1E1E1E'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#121212', '#1E1E1E'],
      shape: shapes.wave,
    }),
    other: genPageTheme({
      colors: ['#121212', '#1E1E1E'],
      shape: shapes.wave,
    }),
    app: genPageTheme({
      colors: ['#121212', '#1E1E1E'],
      shape: shapes.wave,
    }),
    apis: genPageTheme({
      colors: ['#121212', '#1E1E1E'],
      shape: shapes.wave,
    }),
  },
});

export default DarkMode;
